export const runForAtLeast = async (minDurationMs: number, action: () => unknown): Promise<void> => {
  await Promise.allSettled([
    Promise.resolve().then(action),
    new Promise<void>(resolve => {
      setTimeout(resolve, minDurationMs);
    }),
  ]);
};
